import { ConvexReactClient } from "convex/react";

//console.log("CONVEX URL =", process.env.REACT_APP_CONVEX_URL);


export const client = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL);